import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';


@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class CreateComponent implements OnInit {

  customUsername = false;

  user = {
    guid: '',
    display_name: '',
    username: '',
    email: '',
    is_admin: true,
  }
  constructor(private modalController: ModalController,private apiService: ApiService,private globalService: GlobalService,private alertController: AlertController) { }

  ngOnInit() {
  }

  onEmailChange(value: string) {
    if (!this.customUsername) {
      this.user.username = value;
    }
  }

  onCustomUsernameChange(checked: boolean) {
    if (!checked) {
      this.user.username = this.user.email;
    }
  }

  async Close() {
    this.modalController.dismiss(null);
  }

  async Create() {
    this.user.display_name = this.user.display_name.trim();
    this.user.username = this.user.username.trim();
    this.user.email = this.user.email.trim();
    console.log(this.user);
    if(this.user.display_name == "") {
      this.globalService.presentToastMessage('Empty Display Name',false);
      return;
    }
    if(this.user.username == "") {
      this.globalService.presentToastMessage('Empty Username',false);
      return;
    }
    if(!this.globalService.validateEmail(this.user.email))  {
      this.globalService.presentToastMessage('Invalid Email',false);
      return;
    }
    this.user.guid = this.globalService.createGUID();
    let data: any = await this.apiService.get(`username/${this.user.username}`);
    this.globalService.presentToastMessage(data.message,data.success);
    if(data.success) this.modalController.dismiss(this.user);
  }

}
